import React from 'react';

import CardPhoto from '@app/components/UI/CardPhoto/CardPhoto';
import HelmetProvider from '@app/components/UI/HelmetProvider/HelmetProvider';
import Masthead from '@app/components/UI/MastHead/Masthead';
import RichText from '@app/components/UI/RichText/RichText';

const Burial = () => {
	const content = (
		<>
			<p>There are many ways to bury your beloved pet. Here are a few pointers that we have found helpful over the years:</p>
			<ul>
				<li>Check your county ordinances for restrictions.</li>
				<li>Call your local utilities office to come mark your yard. There may be gas lines or water lines buried underground.</li>
				<li>Consider future additions when choosing a location.</li>
				<li>
					Wrap your loved one in a small blanket, t-shirt, or pillow case. Avoid any kind of plastics as they can slow down the natural
					process of absorption back into the earth.
				</li>
				<li>
					An urn or box is not necessary unless you have something particular in mind. Your local pet crematory (or a quick online search,
					PawPods.com is our favorite) will pull up many options if this interests you.
				</li>
				<li>An adequate depth is three to five feet. This is deep enough to prevent other animals investigating the area.</li>
				<li>
					Sprinkle about 1 cup of lime powder (calcium hydroxide) at the bottom of the hole and about 1 cup on top. Lime can be purchased at
					most hardware or livestock feed stores.
				</li>
				<li>At least two feet of soil should be on top of the body.</li>
				<li>
					If you elect to have your pet cremated then buried, using an organic soil mixture along with the cremains will create a
					nutrient-rich mixture that will benefit the earth and help plants around the burial site flourish. (Burying cremains with no
					mixture can be too concentrated in carbon to allow for proper growth.)
				</li>
				<li>
					If you need to delay the burial, you may want to place your pet’s body in an air tight plastic container and put your pet in a
					refrigerator or freezer.
				</li>
				<li>
					Use a headstone or decorative piece to discourage digging. Remember that after euthanasia medications are administered, a pet’s
					body is deadly to other pets.
				</li>
			</ul>
		</>
	);

	return (
		<HelmetProvider>
			<div>
				<Masthead title="Burying Your Pet" imageSrc={require('@app/content/aftercare-burial.jpg')} imageAlt="Pet burial memorial stone" />
				<RichText title="Tips for Burying Your Pet" text={content} />
				<CardPhoto imgURL={require('@app/content/pet-burial.jpg')} title={<>&nbsp;</>} alt="Pet burial headstone" />
			</div>
		</HelmetProvider>
	);
};

export default Burial;
